// tslint:disable
export var DocumentStatus;
(function (DocumentStatus) {
    // UNKN
    DocumentStatus[DocumentStatus["UNKN"] = 0] = "UNKN";
    // LOAD
    DocumentStatus[DocumentStatus["LOAD"] = 1] = "LOAD";
    // PEND
    DocumentStatus[DocumentStatus["PEND"] = 2] = "PEND";
    // MISSINFO
    DocumentStatus[DocumentStatus["MISSINFO"] = 3] = "MISSINFO";
    // PRCSED
    DocumentStatus[DocumentStatus["PRCSED"] = 4] = "PRCSED";
    // UNASGN
    DocumentStatus[DocumentStatus["UNASGN"] = 5] = "UNASGN";
    // NOTRD
    DocumentStatus[DocumentStatus["NOTRD"] = 6] = "NOTRD";
    // SKIP
    DocumentStatus[DocumentStatus["SKIP"] = 7] = "SKIP";
    // EXP
    DocumentStatus[DocumentStatus["EXP"] = 8] = "EXP";
    // Sent
    DocumentStatus[DocumentStatus["Sent"] = 9] = "Sent";
    // Void
    DocumentStatus[DocumentStatus["Void"] = 10] = "Void";
    // Submit
    DocumentStatus[DocumentStatus["Submit"] = 11] = "Submit";
    // Success
    DocumentStatus[DocumentStatus["Success"] = 12] = "Success";
    // Failure
    DocumentStatus[DocumentStatus["Failure"] = 13] = "Failure";
    // Open
    DocumentStatus[DocumentStatus["Open"] = 14] = "Open";
    // Requested
    DocumentStatus[DocumentStatus["Requested"] = 15] = "Requested";
    // Printed
    DocumentStatus[DocumentStatus["Printed"] = 16] = "Printed";
    // PrintFailed
    DocumentStatus[DocumentStatus["PrintFailed"] = 17] = "PrintFailed";
    // NeedsReview
    DocumentStatus[DocumentStatus["NeedsReview"] = 18] = "NeedsReview";
    // UnderReview
    DocumentStatus[DocumentStatus["UnderReview"] = 19] = "UnderReview";
    // DocumentRejected
    DocumentStatus[DocumentStatus["DocumentRejected"] = 20] = "DocumentRejected";
    // DocumentApproved
    DocumentStatus[DocumentStatus["DocumentApproved"] = 21] = "DocumentApproved";
    // SMSSucessfull
    DocumentStatus[DocumentStatus["SMSSucessfull"] = 22] = "SMSSucessfull";
    // SMSFailure
    DocumentStatus[DocumentStatus["SMSFailure"] = 23] = "SMSFailure";
    // PrintQueued
    DocumentStatus[DocumentStatus["PrintQueued"] = 24] = "PrintQueued";
    // Resent
    DocumentStatus[DocumentStatus["Resent"] = 25] = "Resent";
    // Returned
    DocumentStatus[DocumentStatus["Returned"] = 26] = "Returned";
    // Acknowledged
    DocumentStatus[DocumentStatus["Acknowledged"] = 27] = "Acknowledged";
    // Damaged
    DocumentStatus[DocumentStatus["Damaged"] = 28] = "Damaged";
    // UnverifiedAddress
    DocumentStatus[DocumentStatus["UnverifiedAddress"] = 29] = "UnverifiedAddress";
})(DocumentStatus || (DocumentStatus = {}));
DocumentStatus['SENT'] = 9;
DocumentStatus['VOID'] = 10;
DocumentStatus['SUBMIT'] = 11;
DocumentStatus['SUCCESS'] = 12;
DocumentStatus['FAILURE'] = 13;
DocumentStatus['OPEN'] = 14;
DocumentStatus['REQUESTED'] = 15;
DocumentStatus['PRINTED'] = 16;
DocumentStatus['PRINTFAILED'] = 17;
DocumentStatus['NEEDSREVIEW'] = 18;
DocumentStatus['UNDERREVIEW'] = 19;
DocumentStatus['DOCUMENTREJECTED'] = 20;
DocumentStatus['DOCUMENTAPPROVED'] = 21;
DocumentStatus['SMSSUCESSFULL'] = 22;
DocumentStatus['SMSFAILURE'] = 23;
DocumentStatus['PRINTQUEUED'] = 24;
DocumentStatus['RESENT'] = 25;
DocumentStatus['RETURNED'] = 26;
DocumentStatus['ACKNOWLEDGED'] = 27;
DocumentStatus['DAMAGED'] = 28;
DocumentStatus['UNVERIFIEDADDRESS'] = 29;
//# sourceMappingURL=DocumentStatus.js.map